module.exports = __webpack_public_path__ + "static/media/notify-attachment.8068a03b.svg";